import {useMutation} from '@tanstack/react-query';
import {TypeLocalNameEnum} from 'domain/usecases';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useQueryParams} from 'presentation/pages';
import {getExamsAccreditedUnits} from '../../services/getExamsAccreditedUnits';
import {EXAMS_ACCREDITED_NETWORK_DEFAULT_DISTANCE} from './constants';

function useGetExamAccreditedUnitsMutation() {
	const {procedureCode, ufCode, cityName, coordinates, isManualLocation, typeLocalName} =
		useBookingStore(state => state.bookingData);
	const {
		SEARCH_PARAMS: {localityDistance},
	} = useQueryParams();

	const isZone = typeLocalName === TypeLocalNameEnum.ZONA;

	const distance = localityDistance
		? localityDistance
		: EXAMS_ACCREDITED_NETWORK_DEFAULT_DISTANCE;

	const accreditedUnitParams = {
		cdProcedimento: procedureCode ?? '',
		cdUf: isManualLocation ? ufCode?.toUpperCase() : undefined,
		nmCidade: isZone || !isManualLocation ? undefined : cityName?.toUpperCase(),
		coordenadas: isManualLocation ? undefined : coordinates,
		distancia: distance,
		nmZona: isZone ? cityName?.toUpperCase() : undefined,
	};

	return useMutation({
		mutationFn: async ({signal}: {signal?: AbortSignal}) =>
			getExamsAccreditedUnits({
				signal,
				...accreditedUnitParams,
			}),
	});
}

export {useGetExamAccreditedUnitsMutation};
